import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TcoProjectService {

  private tcoUserSubject = new BehaviorSubject<string | null>(null);
  private selectedFileSubject = new BehaviorSubject<string | null>(null);
  private modalIdSubject = new BehaviorSubject<string | null>(null);

  setTcoUserId(userId: string): void {
    this.tcoUserSubject.next(userId);
  }

  getTcoUserId(): Observable<string | null> {
    return this.tcoUserSubject.asObservable();
  }

  setSelectedFile(file: any): void {
    this.selectedFileSubject.next(file);
  }

  getSelectedFile(): Observable<any> {
    return this.selectedFileSubject.asObservable();
  }

  setModalId(id: any): void {
    this.modalIdSubject.next(id);
  }

  getModalId(): Observable<string | null> {
    return this.modalIdSubject.asObservable();
  }
}
